module.exports = __webpack_public_path__ + "img/fuwu_02.cc69e108.png";